import { PaymentCollectionType } from '@features/group-management/constants';

export type DayOptionsType = {
  id: number;
  label: string;
  value: string;
};

// TODO: might change
export interface PaymentCollectionArg {
  interval: string;
  date: Date | string;
  type: PaymentCollectionType;
  isFutureDate?: boolean;
}

export interface CardProps {
  handleActivationDate: (date: string | Date) => void;
  handleIntervalFrequency: (frequency: string) => void;
  selectedDate?: Date | string;
  selectedFrequency?: number;
  type?: PaymentCollectionType;
  isTermDisabled?: boolean;
  nextDueDate?: any;
  minDate?: Date;
  isPaymentLinkSent?: boolean;
  isImmediatePayment?: boolean;
  isEdit?: boolean;
  isCustomTerm?: boolean;
  hideAdvanced?: boolean;
  hideFirstDayFrequency?: boolean;
}

export enum PaymentCollectionComponentType {
  DEFAULT = 'default',
  MONTHLY = 'monthly',
  WEEKLY = 'weekly',
  BY_TERM = 'by_term',
  ONCE = 'once'
}

export interface PaymentCollectionProps {
  isOpen: boolean;
  cancelButtonLabel: string;
  confirmButtonLabel: string;
  cancelButtonStyle?: string;
  confirmButtonStyle?: string;
  handleConfirm: (item: PaymentCollectionArg) => void;
  handleCancel: () => void;
  isEditGroup?: boolean;
  type?: PaymentCollectionComponentType;
  className?: string;
  selectedDate?: Date | string;
  selectedtype?: PaymentCollectionType;
  selectedFrequency?: any;
  nextDueDate?: any;
  isPaymentLinkSent?: boolean;
  isImmediatePayment?: boolean;
  isCustomTerm?: boolean;
  source?: 'group' | 'member';
  isGroupMonthlyFirstDay?: boolean;
}
